module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/messages/message.component.scss
// module id = ./src/app/components/messages/message.component.scss
// module chunks = main